import React from 'react';
import styled from 'styled-components';
import { color, Text } from '@starrez/starryui9';
import { ChevronDownIcon } from '@starrez/starryui';
import { useProps } from './FolderDropdown';
import { strings } from '../../localisation';

interface IControlProps {
    onClick: () => void;
    caption?: string;
}

export const Control = ({ onClick, caption = strings.Label_Select }: IControlProps) => {
    const { disabled, invalid } = useProps();
    return (
        <StyledButton type="button" onClick={onClick} disabled={disabled} aria-invalid={invalid} invalid={invalid}>
            <Text color={color.Grey.G80} variant="normal.regular">
                {caption}
            </Text>
            <ChevronDownIcon />
        </StyledButton>
    );
};

interface IStyledButton {
    disabled?: boolean;
    invalid?: boolean;
}

const StyledButton = styled.button<IStyledButton>`
    height: 40px;
    border: 1px solid ${({ invalid }) => (invalid ? color.Red.R60 : color.Grey.G30)};
    box-sizing: border-box;
    border-radius: 4px;
    display: grid;
    align-items: center;
    grid-template-columns: 1fr auto;
    width: 100%;
    padding: 0 12px 0 16px;
    text-align: left;
    background: transparent;
    color: ${color.Grey.G80};
    opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};

    &[aria-invalid='true'] {
        border-color: ${color.Red.R60};
    }
`;
